import { render, staticRenderFns } from "./TimeLimitSetting.vue?vue&type=template&id=7382710a&scoped=true"
import script from "./TimeLimitSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeLimitSetting.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TimeLimitSetting.vue?vue&type=style&index=0&id=7382710a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7382710a",
  null
  
)

export default component.exports